<template>
	<div class="editor">
		<div class="address_title">
			<div class="address_title_left" v-on:click="xreturn">
				<img src="../../images/dir_left.png" />
			</div>
			编辑地址
			<div class="address_title_right" v-on:click="del_address">
				<img src="../../images/delete.png" />
			</div>
		</div>

		<div class="editor_div">
			<div>
				<div>
					店铺名称
				</div>
				<input placeholder="请输入收货人姓名" v-model:value="parameter.name">
			</div>
			<div>
				<div>
					手机号
				</div>
				<input type="text" maxlength="11" 
				 onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')"
				 placeholder="请输入收货人手机号" v-model:value="parameter.phone">
			</div>
			<div>
				<div>
					选择地区
				</div>
				<input type="text" style="width: 40%;" v-model="carmodel" value="" readonly v-model:value="parameter.region"
				 placeholder="请选择地区">
				<div class="region_list">
					<span id="region" @click="show = true"></span>
				</div>
			</div>
			<div>
				<div>
					详细地址
				</div>
				<input placeholder="街道，楼牌号等" v-model:value="parameter.nexadders">
			</div>
			<div style="text-align: right;line-height: 0.98rem;">
				<div style="float: left;text-align: left;">
					设置默认地址
				</div>
				<van-switch class="list" v-model="checked"  size="24px" />
			</div>
		</div>

		<!-- <div class="app"> -->
		<van-cell-group>
			<!--cell+popup+area省市区的坑-->
			<!-- <van-cell></van-cell> -->
			<van-popup v-model="show" position="bottom">
				<van-area ref="area" value="110000" :area-list="areaList" @change="onChange" @confirm="show = false" @cancel="show = false" />
			</van-popup>
		</van-cell-group>

		<button class="but" v-on:click="save">保存地址</button>
	</div>
</template>

<script>
	import areaObj from "../commonality/address3.js";
	import {
		Cell,
		CellGroup,
		Popup,
		Field,
		Area,
		Picker
	} from 'vant'
	import API from "../../lmj_Api/api";

	export default {
		components: {
			VanCell: Cell,
			VanCellGroup: CellGroup,
			VanPopup: Popup,
			VanField: Field,
			VanArea: Area,
			VanPicker: Picker
		},
		data() {
			return {
				name: "addresseditor",
				uid: this.$store.getters.get_user_id,
				carmodel: '',
				areaList: { // 地址三联动的
					province_list: areaObj.province_list,
					city_list: areaObj.city_list,
					county_list: areaObj.county_list
				},
				parameter: {
					name: this.$route.params.name,
					phone: this.$route.params.phone,
					region: this.$route.params.addr,
					nexadders: this.$route.params.address,
					id: this.$route.params.id,
					status: this.$route.params.status,
				},
				show: false,
				show1: false,
				checked:true,
			}
		},
		mounted() {
			this.btn_s_h();
		},
		methods: {
			btn_s_h(){
				 if(this.parameter.status == 0){
					 this.checked = false;
				} else {
					this.checked = true;
				}
			},
			onChange(picker, value, index) {
				this.parameter.region = '';
				for (var i = 0; i < value.length; i++) {
					this.parameter.region += value[i].name;
				}
			},
			save() {
				// this.stopColor();
				//点击编辑 处理
				var that = this;
				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 500,
				});
				var url = API.addressSave;
				var that = this;
				var status = 0;
			
				if(that.checked == true) {
					status = 1;
				} 
				var _data = {
					name:that.parameter.name,
					phone:that.parameter.phone,
					addr: that.parameter.region,
					address: that.parameter.nexadders,
					id: that.parameter.id,
					default: status
				};		
				this.axios.post(url, _data)
				.then(res=> {
					console.log(res)
					if(res.data.code == 200) {
						this.$toast.success({
							message: '修改成功',
							forbidClick: true,
							duration: 500,
						});
						window.setTimeout(()=>{
            that.$router.push({path:'/addressmanagement'});
						},1000)
					}
				})
			},
			
			//删除地址
			del_address() {
				var that = this;
				var url = API.del;
				this.$dialog.confirm({
			  		// title: '标题',
					message: '是否删除当前地址',
					width:"5.46rem",
					className:'tit',
				}).then(() => {
				//确认 回到登入页面
				this.axios.post(url,{id: that.parameter.id})
					.then(res=> {
						if(res.data.code == 200) {
						that.parameter.name = '';
						that.parameter.phone = '';
						that.parameter.region = '';
						that.parameter.nexadders = '';
            that.$router.push({path:'/addressmanagement'});
					}
				})
			}).catch(() => {
			  // on cancel
			});
				
			},

			//返回
			xreturn(){
				// this.$router.go(-1)
				this.$router.push({path:'/addressmanagement'});
			}

		}
	}
</script>
<style lang="less" scoped>
	* {
		margin: 0;
		padding: 0;
	}
	html, #app, .editor {
		height: 100%;
		width: 100%;
	}
	input {
		border: 0;
		background: transparent;
		// outline: none;
		margin: 0;
		padding: 0;
		display: block;
		font-size: 0.24rem;
	}

	input::-webkit-input-placeholder {
		/* Chrome/Opera/Safari */
		color: rgba(216, 216, 216, 1);
	}

	input::-moz-placeholder {
		/* Firefox 19+ */
		color: rgba(216, 216, 216, 1);
	}

	input:-ms-input-placeholder {
		/* IE 10+ */
		color: rgba(216, 216, 216, 1);
	}

	input:-moz-placeholder {
		/* Firefox 18- */
		color: rgba(216, 216, 216, 1);
	}

	.address_title {
		width: 7.5rem;
		height: 0.88rem;
		background: linear-gradient(90deg, rgba(123, 212, 255, 1) 0%, rgba(92, 186, 255, 1) 100%);
		font-size: 0.3rem;
		font-family: PingFangSC-Medium, PingFang SC;
		color: rgba(255, 255, 255, 1);
		text-align: center;
		line-height: 0.88rem;
		position: relative;
	}

	.address_title>div {
		position: absolute;
		top: 0rem;
		text-align: center;
	}

	.address_title>div>img {
		width: 0.18rem;
		height: 0.34rem;
		display: inline-block;
		vertical-align: middle;
	}

	.address_title>.address_title_left {
		left: 0rem;
		width: 1.06rem;
		height: 100%;
		line-height: 0.88rem;
	}

	.address_title>.address_title_right {
		right: 0rem;
		width: 1.12rem;
		height: 100%;
		line-height: 0.88rem;
	}

	.address_title>.address_title_right>img {
		width: 0.36rem;
		height: 0.38rem;
		display: inline-block;
		vertical-align: middle;
	}

	.editor_div>div {
		width: 6.72rem;
		margin: auto;
		border-bottom: 0.01rem solid rgba(239, 239, 239, 1);
		height: 0.98rem;
	}

	.editor_div>div>div {
		// display: inline-block;
		width: 1.9rem;
		line-height: 0.98rem;
		height: 0.98rem;
		font-size: 0.3rem;
		font-family: PingFangSC-Regular, PingFang SC;
		color: rgba(99, 99, 99, 1);
		// vertical-align: top;
	  float: left;
	}

	.editor_div>div>input {
		height: 0.98rem;
		display: inline-block;
		vertical-align: top;
		font-size: 0.28rem;
		font-family: PingFangSC-Medium, PingFang SC;
		color: rgba(99, 99, 99, 1);
		width: 67%;
	}

	.editor_div>div>input::-ms-input-placeholder {
		color: rgba(216, 216, 216, 1);
	}

	#region {
		display: inline-block;
		width: 0.8rem;
		height: 0.32rem;
	}

	#region {
		border-left: 0.04rem solid white;
		background: url("../../images/list_bottom.png") 0.27rem 0.03rem no-repeat;
		background-size: 40%;
	}

	.editor_div>div>.region_list {
		float: right;
		text-align: right;
	}

	.editor_div>div>.list {
		height: 0.56rem;
		width: 1rem;
	  float: right;
	  margin-top: 0.15rem;
	}

	.editor_div>div>.list>div {
		margin: 0.01rem;
		height: 0.55rem;
		width: 0.55rem;
	}

	.van-switch--on {
		background: #4bd863;
	}

	.but {
		width: 100%;
		height: 1.08rem;
		font-size: 0.32rem;
		font-family: PingFangSC-Medium, PingFang SC;
		line-height: 1.08rem;
		border: 0rem;
		border-radius: 0rem;
		position: fixed;
		bottom: 0rem;
		left: 0rem;
		color: rgba(255, 255, 255, 1);
		background: linear-gradient(90deg, rgba(123, 212, 255, 1) 0%, rgba(92, 186, 255, 1) 100%);
	}
</style>



// WEBPACK FOOTER //
// src/components/xy/addresseditor.vue